import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionService } from '../services/session.service';
import { API } from '../constants/api-endpoints';

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(SessionService);

  // 1) No tocar login
  if (req.url === API.authAdmin.login()) {
    return next(req);
  }

  // 2) Endpoint protegido por TEMP TOKEN
  if (req.url === API.authAdmin.changeTempPassword()) {
    const tempToken = sessionStorage.getItem('temp_token');
    if (!tempToken) return next(req);

    const tempReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${tempToken}`,
      },
    });
    return next(tempReq);
  }

  // 3) Token normal para el resto
  const token = session.token();
  if (!token) return next(req);

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(authReq);
};
